import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";

export const isAuthenticated = (state: ApplicationState) => {
    const session = getSession(state);
    return session.isAuthenticated && !session.isGuest;
};

export const signInUrl = (state: ApplicationState) => {
    const getSignInUrl = getPageLinkByPageType(state, "SignInPage")?.url;
    return !getSignInUrl ? "/MyAccount/SignIn" : getSignInUrl;
};
